import { createRouter, createWebHistory } from 'vue-router'
import { portalRoutes } from './portal-routes'
import { homeRoutes } from './home-routes'
import { portalnewRoutes } from './portalnew-routes'
import { setupRouterGuards } from './guards'

/**
 * 根据环境变量选择路由配置
 */
function getRoutes() {
  const entry = ENTRY_TYPE || 'portal'
  if (entry === 'home') {
    homeRoutes.forEach(route => console.log(`  - ${route.path} (${String(route.name) || 'unnamed'})`))
    return homeRoutes
  } else if (entry === 'portalnew') {
    portalnewRoutes.forEach(route => console.log(`  - ${route.path} (${String(route.name) || 'unnamed'})`))
    return portalnewRoutes
  } else {
    return portalRoutes
  }
}

/**
 * 创建路由实例
 */
const router = createRouter({
  history: createWebHistory('/'),
  routes: getRoutes(),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0 }
  }
})

// 设置路由守卫
setupRouterGuards(router)

export default router
